__turbopack_context__.v({
  "community-powered-ribbon": "community-powered-ribbon-module-scss-module__3SzhlW__community-powered-ribbon",
});
